document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', async function (e) {
    const button = e.target.closest('.add-stack');
    if (!button) return;

    e.preventDefault();

    const ids = [
      button.getAttribute('data-product1'),
      button.getAttribute('data-product2'),
      button.getAttribute('data-product3')
    ].filter(Boolean);

    if (!ids.length) return;

    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.style.pointerEvents = 'none';

    try {
      const items = ids.map(function (id) {
        return {
          id: Number(id),
          quantity: 1
        };
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error('Failed to add stack');
      }

      const cartCountEls = document.querySelectorAll('.cart-count');
      if (cartCountEls.length) {
        const currentCount = parseInt(cartCountEls[0].textContent || '0', 10) || 0;
        const newCount = currentCount + items.length;
        cartCountEls.forEach(function (el) {
          el.textContent = newCount;
        });
      }

      const drawer = document.getElementById('NutriCartDrawer');
      const overlay = document.querySelector('.nutri-cart-drawer__overlay');

      if (drawer && overlay) {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      console.error(error);
      alert('Could not add this stack to cart.');
    } finally {
      button.textContent = originalText;
      button.style.pointerEvents = '';
    }
  });
});